// PRODUCT MAIN SECTION SLIDER IMAGES POPUP CODE
document.addEventListener("DOMContentLoaded", function () {

  /* ============================================================
      GLOBAL PROGRESS BARS CREATION + FUNCTIONALITY
     ============================================================ */

  function createGlobalProgressBars() {
    const slides = document.querySelectorAll(".kr--video_modal_item");
    const globalContainer = document.querySelector(".kr--all-progress-bars");

    if (!slides.length || !globalContainer) return;

    slides.forEach(() => {
      const bar = document.createElement("div");
      bar.className = "kr--global-bar";
      bar.innerHTML = `<span></span>`;
      globalContainer.appendChild(bar);
    });

    return document.querySelectorAll(".kr--global-bar span");
  }

  const globalBars = createGlobalProgressBars();


  /* ============================================================
      POPUP + SLIDER INITIALIZATION
     ============================================================ */

  const videoItems = document.querySelectorAll(".lx-slider-image-item");
  const popup = document.querySelector(".kr--video-modal__carousel");
  const closeBtn = popup?.querySelector(".kr_modal_close-button");
  const popupVideos = popup?.querySelectorAll("video");

  const videoSwiper = new Swiper(".kr--video-modal__carousel_block", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    navigation: {
      nextEl: ".kr_modal_next--button",
      prevEl: ".kr_modal_prev--button",
    },
    on: {
      slideChange: function () {
        const index = videoSwiper.activeIndex;

        popupVideos.forEach(v => {
          v.pause();
          v.currentTime = 0;
        });
        if (globalBars) {
          globalBars.forEach(b => b.style.width = "0%");
        }
        setTimeout(() => {
          const active = document.querySelector(".swiper-slide-active video");
          if (active) {
            active.muted = false;
            active.play();
            attachProgress(active, index);
          }

          const muteBtn = document.querySelector(".swiper-slide-active .kr--video-carousel__mute-control");
          if (muteBtn) $(muteBtn).addClass("active");
        }, 150);
      },
    },
  });

  if (!videoItems.length || !popup) return;


  /* ============================================================
      ATTACH PROGRESS HANDLER FOR EACH VIDEO
     ============================================================ */

  function attachProgress(video, index) {
    if (!globalBars || !globalBars[index]) return;

    const bar = globalBars[index];
    bar.style.width = "0%";

    video.addEventListener("timeupdate", () => {
      if (video.duration) {
        const percentage = (video.currentTime / video.duration) * 100;
        bar.style.width = percentage + "%";
      }
    });

    video.addEventListener("ended", () => {
      bar.style.width = "100%";
    });
  }


  /* ============================================================
      CLICK THUMBNAIL → OPEN POPUP + GO TO SLIDE
     ============================================================ */

  videoItems.forEach((item) => {
    item.addEventListener("click", () => {
      const metaIndex = item.getAttribute("meta__index");

      popup.classList.add("active");
      document.body.classList.add("no-scroll");

      popupVideos.forEach(v => {
        v.pause();
        v.currentTime = 0;
      });

      const slideEl = document.querySelector(`.kr--vm_card_item[video__index="${metaIndex}"]`);
      if (slideEl) {
        const slideNode = slideEl.closest(".swiper-slide");
        const index = [...slideNode.parentNode.children].indexOf(slideNode);

        videoSwiper.slideTo(index);

        setTimeout(() => {
          const video = slideEl.querySelector("video");
          if (video) {
            video.muted = false;
            video.play();
            attachProgress(video, index);
          }

          const muteControl = slideEl.querySelector(".kr--video-carousel__mute-control");
          if (muteControl) $(muteControl).addClass("active");
        }, 200);
      }
    });
  });


  /* ============================================================
      CLOSE POPUP
     ============================================================ */

  closeBtn?.addEventListener("click", () => {
    popup.classList.remove("active");
    document.body.classList.remove("no-scroll");
    popupVideos.forEach(v => v.pause());
  });

  popup.addEventListener("click", (e) => {
    if (e.target.classList.contains("kr--video-modal__carousel")) {
      popup.classList.remove("active");
      document.body.classList.remove("no-scroll");
      popupVideos.forEach(v => v.pause());
    }
  });


  /* ============================================================
      MUTE / UNMUTE BUTTON
     ============================================================ */

  $(document).on("click", ".kr--video-carousel__mute-control", function () {
    const video = $(this).closest(".kr--vm_card_item").find("video")[0];
    if (video.muted) {
      video.muted = false;
      $(this).addClass("active");
    } else {
      video.muted = true;
      $(this).removeClass("active");
    }
  });


  /* ============================================================
      PLAY FIRST SLIDE'S PROGRESS ON LOAD
     ============================================================ */

  setTimeout(() => {
    const first = document.querySelector(".swiper-slide-active video");
    if (first) attachProgress(first, 0);
  }, 350);
});
